module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-tablet-738x57@2x-80.cce1ad66.jpg";